class SiteElementHide
    extends QueryElement<HTMLElement> {


    constructor(element: HTMLElement, site: Site) {
        super(element);

        this.on("click", (e) => {
            this.parent()?.toggleClass("hide");
            site.resize();
            e.stop();
        })
    }

    async remove(removeInner?: boolean) {
        super.remove(removeInner);
    }

}